/** Token the Mac App Store desktop build appends to navigator.userAgent. */
export const MAC_APP_STORE_UA_TOKEN = "AileChatMacAppStore/";

export function isMacAppStoreUserAgent(userAgent: string | null | undefined): boolean {
  return typeof userAgent === "string" && userAgent.includes(MAC_APP_STORE_UA_TOKEN);
}

export function isMacAppStoreClient(): boolean {
  return typeof navigator !== "undefined" && isMacAppStoreUserAgent(navigator.userAgent);
}
